import React, { useEffect } from 'react';
import { Button, Table, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  ExecutionErrorType,
  markErrorAsSeen,
  retrieveExecutionErrors,
  selectors,
} from 'state';
import { formatters } from 'services';
import type { TableColumnGroupType as ColumnGroupType, TableColumnType as ColumnType } from 'antd';
import { dateWithTimeSeconds } from 'services/formatters';

const { Title } = Typography;

const ExecutionErrors: React.FC = () => {
  const dispatch = useDispatch();
  const executionErrors = useSelector(selectors.executionErrorsSelector);
  const executionErrorsList = Object.values(executionErrors.items);
  const data = executionErrorsList.filter(item => item.seen === false);
  useEffect(() => {
    if (!executionErrors.fetched) {
      dispatch(retrieveExecutionErrors({}));
    }
  }, []);

  const columns: ((
    | ColumnGroupType<ExecutionErrorType>
    | ColumnType<ExecutionErrorType>
  ) & {
    dataIndex: string;
  })[] = [
    {
      title: 'id',
      dataIndex: 'id',
      fixed: 'left',
    },
    {
      title: 'error',
      dataIndex: 'text',
      render: (text: string) => (
        <div style={{ whiteSpace: 'normal' }}>{text || '--'}</div>
      ),
    },
    {
      title: 'timestamp',
      dataIndex: 'timestamp',
      // width: 250,
      defaultSortOrder: 'descend',
      sorter: (a: ExecutionErrorType, b: ExecutionErrorType) => {
        const dateA = formatters.dateWithTime(a.timestamp || '');
        const dateB = formatters.dateWithTime(b.timestamp || '');
        return dateA.localeCompare(dateB);
      },
      render: val => formatters.dateWithTimeSecondsMiliseconds(val),
      fixed: 'right',
    },
    {
      title: '',
      dataIndex: 'id',
      render: (id, row) => {
        // console.log(val);
        // console.log(row);
        return (
          <Button
            onClick={() => {
              dispatch(markErrorAsSeen({ id: id }));
            }}
          >
            X
          </Button>
        );
      },
      align: 'center',
    },
  ];

  return (
    <div>
      <Typography.Title level={4}>Errors</Typography.Title>
      <Table
        // style={{ width: '1000px' }}
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 10 }}
        bordered
      />
    </div>
  );
};
// deploy
export default ExecutionErrors;
